import React, { useEffect, useState } from 'react';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router-dom';
import { MerchantEnquiry } from 'Components/Api/EzyPayAEPSAPI';
import { Container, Grid } from '@material-ui/core';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
const CustomContainer = HOCLoader(Container);
export const EzyPayAEPS = () => {
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');

    const history = useHistory();
    const CheckMerchantActivated = async () => {
        const response = await MerchantEnquiry();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        var data = JSON.parse(response.data);

        if (data.Message === 'Merchant not exists') {
            setResponseMessage(data.Message);
            history.push('/EZPayAEPSMerchantActivation');
        }

        if (data.Message === 'Activated') {
            setResponseMessage(data.Message);
            history.push('/EzyPayAEPSTransaction');
        }

        if (data.Message === 'Authentication Failed') {
            setResponseMessage(data.Message);
            setSeverity('error');
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
        }

        if (
            data.Message ===
            'Activation request in process, waiting for approval'
        ) {
            setStatus('PROCESS');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);

            setResponseMessage(data.Message);
            setSeverity('success');
            setIsError(true);
            setMessage(data.Message);
        }

        setMessage(data.Message);
    };

    useEffect(() => {
        CheckMerchantActivated();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <h2 className={classes.PaperHead_h2}>
                        Checking merchant activation.........
                    </h2>
                </Grid>

                <Grid item xs={6}>
                    <h2 className={classes.PaperHead_h2}>{Message} </h2>
                </Grid>
                <Grid item xs={6}></Grid>
            </Grid>
            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
